import ProductGrid from "@/components/ProductGrid";

export default function Planters() {
  return (
    <ProductGrid
      category="planters"
      eyebrow="Floral Planters"
      title="Beautiful. Fresh. Inspired."
      blurb="Custom-designed arrangements to bring living color into your domestic space."
    />
  );
}
